import React from "react";
import { Route } from "react-router-dom";
import Home from "./Home";

const HomeContainer = ({ match }) => (
  <div className="containerContent">
    <Route exact path="/" component={Home} />
  </div>
);

export default HomeContainer;
